import { IconBuildingSkyscraper, IconCancel, IconDoorExit, IconExclamationCircle, IconHomeRibbon, IconShip } from "@tabler/icons-react"

const StatusType = [
    {
      value: 'OFFICE',
      label: 'Office',
      key: 'OFFICE',
      color: "#e04f86",
      color2: "#b856a1",
      icon: <IconBuildingSkyscraper color="#fff" />
    },
    {
      value: 'WFH',
      label: 'Work From Home',
      key: 'WFH',
      color: "#875fbf",
      color2: "#5947b9",
      icon: <IconHomeRibbon color="#fff" name="home-city" size={30} />
    },
    { 
      value: 'SHIP_VISIT',
      label: 'Ship Visit',
      key: 'SHIP_VISIT',
      color: "#60c3f1",
      color2: "#6e95da",
      icon: <IconShip color="#fff" />
    },
    {
      value: 'ON_LEAVE',
      label: 'On Leave',
      key: 'ON_LEAVE',
      color: "#f8ba38",
      color2: "#ee8959",
      icon: <IconDoorExit color="#fff" />
    },
    {
      value: 'OTHERS',
      label: 'Others',
      key: 'OTHERS',
      color: "#35b6d0",
      color2: "#2377b5",
      icon: <IconExclamationCircle color="#fff" />
    },
    {
      value: 'NOT_UPDATED',
      label: 'Not Updated',
      key: 'NOT_UPDATED',
      color: "#000",
      color2: "#555",
      icon: <IconCancel color="#fff" />
    },
]

export default StatusType